/** @jsx isolateComponent */

import { Fragment, ReactNode, useState } from 'react';

import { FlexLayout, MessageBar } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Button, Margin } from '@zapier/design-system';
// @ts-ignore: "has no exported member 'PaymentApp'" - yes it does
import { PaymentApp } from '@zapier/payment';

import { useSize } from '@zapier/promotions/src/hooks';
import { BillingIntervalOptions } from './BillingIntervalOptions';

type Props = {
  acceptOffer: (planId: string) => void;
  children: ReactNode;
  error: string | undefined;
  isPaymentMethodProvided: boolean;
  monthlyIntervalAmount: number;
  monthlyPlanId: string;
  yearlyIntervalAmount: number;
  yearlyPlanId: string;
};

export const MultiIntervalOfferModalView = ({
  acceptOffer,
  children,
  error,
  isPaymentMethodProvided,
  monthlyIntervalAmount,
  monthlyPlanId,
  yearlyIntervalAmount,
  yearlyPlanId,
}: Props) => {
  const size = useSize();
  const [selectedPlanId, setSelectedPlanId] = useState(yearlyPlanId);

  return (
    <Fragment>
      {children}

      <Margin margin="20px 0">
        <BillingIntervalOptions
          monthlyIntervalAmount={monthlyIntervalAmount}
          monthlyPlanId={monthlyPlanId}
          onSelectPlanId={setSelectedPlanId}
          selectedPlanId={selectedPlanId}
          yearlyIntervalAmount={yearlyIntervalAmount}
          yearlyPlanId={yearlyPlanId}
        />
      </Margin>

      <Margin margin="0 auto 20px 0">
        <PaymentApp />
      </Margin>

      {!!error && (
        <Margin margin="0 0 20px 0">
          <MessageBar type="error">{error}</MessageBar>
        </Margin>
      )}

      <FlexLayout
        direction={size === 'small' ? 'column' : 'row'}
        justify="center"
      >
        <Button
          disabled={!isPaymentMethodProvided}
          hasShadow={true}
          isFullWidth={size === 'small'}
          onClick={() => acceptOffer(selectedPlanId)}
        >
          Upgrade plan
        </Button>
      </FlexLayout>
    </Fragment>
  );
};
